<template>
  <a @click="toCheckout" :href="url">
    <button class="purchase-btn call-to-action cart">
      <span v-if="course.course_status==='FUNDING'">
        馬上購買
        <span v-if="text==='nav'">NT$ {{formatNumber(this.course.funding_price)}}</span>
      </span>
      <span v-else>
        立即購買
        <span v-if="text==='nav'">NT$ {{formatNumber(this.course.sale_price)}}</span>
      </span>
      
    </button>
  </a>
</template>

<script>
/* eslint-disable */

export default {
  name: 'AppToCheckout',
  props: ['url', 'text', 'is_auth', 'course'],
  computed: {
    
  },
  methods: {
    formatNumber(num) {
      let number = parseInt(num)
      return number ? number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'): '0'
    },
    toCheckout(e) {
      if (this.is_auth === 'False') {
        e.preventDefault()
        localStorage.setItem('loginRedirect', `/checkout/${this.course.slug_name}`)
        this.$emit('to-login', `/checkout/${this.course.slug_name}`)
      } else {
        localStorage.removeItem('loginRedirect')
      }
    }
  },
  created() {
  }
}
</script>

<style scoped lang="scss">

</style>
